
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:root{
--sic-cta--default--text-color:var(--color-primary-default);
--sic-cta--default--font-size:var(--body-helper-font-size);
--sic-cta--default--font-size--sm-locked:calc(var(--body-helper-min-font-size));
--sic-cta--default--font-size--lg:var(--body-01-font-size);
--sic-cta--default--line-height:var(--line-height-xl);
--sic-cta--default--family:var(--ff-body);
--sic-cta--default--weight:var(--fw-bold);
--sic-cta--default--padding:var(--spacing-01) 0;
--sic-cta--default--margin:0 var(--spacing-01) 0 0;
--sic-cta--default--radius:var(--border-radius-outline-default);
--sic-cta--default--border-color:var(--color-primary-default);
--sic-cta--default--border-width:var(--border-width-thicker);
--sic-cta--file-icon-size:var(--spacing-04);
--sic-cta--default--outline-width--focus:var(--border-width-thicker);
--sic-cta--default--outline-offset--focus:var(--border-width-thicker);
--sic-cta--default--text-color--disabled:var(--color-neutral-light);
}

.sic-bg--primary-default a.sic-cta .last-word::after, .sic-bg--secondary-default a.sic-cta .last-word::after, .sic-bg--secondary-light a.sic-cta .last-word::after, .sic-bg--primary-default button.sic-cta .last-word::after, .sic-bg--secondary-default button.sic-cta .last-word::after, .sic-bg--secondary-light button.sic-cta .last-word::after{
      background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23FFFFFF' viewBox='0 0 320 512'%3E%3Cpath d='M285.476 272.971 91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'/%3E%3C/svg%3E");
    }

.sic-bg--primary-default a.sic-cta.external .last-word::after, .sic-bg--primary-default a.sic-cta[target='_blank'] .last-word::after, .sic-bg--secondary-default a.sic-cta.external .last-word::after, .sic-bg--secondary-default a.sic-cta[target='_blank'] .last-word::after, .sic-bg--secondary-light a.sic-cta.external .last-word::after, .sic-bg--secondary-light a.sic-cta[target='_blank'] .last-word::after, .sic-bg--primary-default button.sic-cta.external .last-word::after, .sic-bg--primary-default button.sic-cta[target='_blank'] .last-word::after, .sic-bg--secondary-default button.sic-cta.external .last-word::after, .sic-bg--secondary-default button.sic-cta[target='_blank'] .last-word::after, .sic-bg--secondary-light button.sic-cta.external .last-word::after, .sic-bg--secondary-light button.sic-cta[target='_blank'] .last-word::after{
        background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 25'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill='%23FFFFFF' fill-rule='evenodd' d='M20.25 15.824h-1.5a.739.739 0 0 0-.75.727v5.086H3V7.105h6.75c.414 0 .75-.325.75-.726V4.926a.739.739 0 0 0-.75-.727h-7.5C1.007 4.2 0 5.175 0 6.38v15.984c0 1.204 1.007 2.18 2.25 2.18h16.5c1.243 0 2.25-.976 2.25-2.18v-5.812a.739.739 0 0 0-.75-.727Zm2-14.531h-7.438c-.724 0-1.312.57-1.312 1.271v.85c.01.337.158.657.41.888.254.232.592.356.94.347L18 4.562 6.331 15.783l-.003.004a1.066 1.066 0 0 0 0 1.54L7.45 18.41l.003.003c.44.423 1.152.421 1.59-.004L20.625 7.105l-.088 3.052v.035c0 .703.588 1.272 1.312 1.272h.838c.725 0 1.313-.57 1.313-1.272V2.988c0-.936-.783-1.695-1.75-1.695Z' clip-rule='evenodd'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 .5h24v24H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
      }
`;